import React from "react";
import JamezzFormV2 from "../JamezzForm/JamezzFormV2";
import TranslationWrapper, { getTranslation } from "../../components/TranslationWrapper/TranslationWrapper";
import Algemeen from "./Tabs/Algemeen";
import AuthProvider from "../../auth/AuthProvider";
import { formatTitle } from "../../../utils/formatting";

function GatewaysForm() {
  return (
    <AuthProvider prefix={"gateways"}>
      <JamezzFormV2
        computedPageTitle={function (model) {
          return formatTitle(this.pageTitle, model.naam);
        }}
        endPoint={"core/gateways"}
        pageTitle={getTranslation("gateways.form.pageTitle", "Gateways")}
        rootRight={"gateways"}
        tabs={[
          {
            right: "algemeen",
            tabButton: <TranslationWrapper tDefault={"Algemeen"} tKey={"gateways.form.tabs.algemeen"} />,
            tabContent: <Algemeen />,
          },
        ]}
      />
    </AuthProvider>
  );
}

export default GatewaysForm;
